import APIContext from 'contexts/base/APIContext'

export default class LogInstructionsContext extends APIContext{
  static contextName = 'logInstructions'
}
